import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {BehaviorSubject, Observable, of, Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, map, startWith, switchMap} from 'rxjs/operators';
import {UntypedFormControl} from '@angular/forms';
import {PredictService} from '../../services/predict.service';
import {AuthService} from '../../services/auth.service';

@Component({
    selector: 'app-zone-autocomplete',
    template: `
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Territoire</mat-label>
      <input type="text" [required]="required" matInput [formControl]="myControl" (keyup)="getData(myControl.value)" [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
        <mat-option (onSelectionChange)="zone.emit(_zone)" *ngFor="let _zone of listUser$ | async" [value]="_zone">
          <b>{{_zone.name}}</b> - {{_zone.code_zone}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  `,
    standalone: false
})
export class ZoneAutocompleteComponent implements OnInit {

  @ViewChild('auto', {static: false}) auto;

  @Input() required: boolean;
  @Output() zone = new EventEmitter();

  user;
  myControl = new UntypedFormControl();
  _listUser: any[] = [];
  listUser$: BehaviorSubject<any[]> = new BehaviorSubject([]);

  constructor(
    public predictService: PredictService,
    public authService: AuthService,
  ) {
    this.authService.getSession().subscribe(user => {
      this.user = user;
    });
  }

  ngOnInit(): void {
    this.myControl.valueChanges
      .pipe(
        filter(a => !!a),
        debounceTime(500),
        distinctUntilChanged(),
        switchMap((value: string) => {
          if (typeof value !== 'string') {
            return of(this._listUser);
          }
          // Get data according to the filled value
          return this.getData(value);
        })
      )
      .subscribe((data: any) => {
        this._listUser = data;
        this.listUser$.next(data);
      });
  }

  getData(term): any {
    return this.predictService.getZoneWithFilters(term, {
      code_zone: this.user?.zones.map(z => z.code_zone) || [],
    });
  }

  displayFn(user): string {
    return user && user.name ? `${user.name} - ${user.code_zone}`  : '';
  }
}

